import Cookies from 'js-cookie';
import { login, register, demoAccess, recovery, logout } from '../../services/api/account';
import { sendSmsCode, confirmSmsCode } from '../../services/api/verification';

export const auth = {
    namespaced: true,
    state: {
        demoAccessed: false,
        registeredEmail: undefined,
        register: {
            seconds: +Cookies.get('register:timer') || 0,
        },
        demoAccess: {
            seconds: +Cookies.get('demoAccess:timer') || 0,
        },
    },
    mutations: {
        registered(state, email) {
            state.registeredEmail = email;
        },

        demoAccessed(state) {
            state.demoAccessed = true;
        },

        updateTimer(state, timer) {
            Cookies.set(
                timer.form + ':timer',
                timer.seconds,
                {
                    expires: timer.seconds / 60 / 60 / 24,
                }
            );
            state[timer.form].seconds = timer.seconds;
        },

        resetState(state) {
            state.registeredEmail = undefined;
            state.demoAccessed = false;
        }
    },
    actions: {
        resetState({ commit }) {
            commit('resetState');
        },

        logout({ commit, dispatch }) {
            dispatch('deauthorize', undefined, { root: true });

            return logout();
        },
        login({ commit, dispatch }, values) {
            return login(values)
                .then((res) => {
                    dispatch('authorize', true, { root: true });
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });

                    return Promise.reject(res);
                });
        },
        recovery({ commit, dispatch }, values) {
            return recovery(values)
                .catch((res) => {
                    dispatch('error', res, { root: true });

                    return Promise.reject(res);
                });
        },
        register({ commit, dispatch }, values) {
            return register(values)
                .then((res) => {
                    // commit('registered', values.email);
                    // dispatch('authorize', true, { root: true });
                    //commit('demoAccessed');
                    return res;
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });

                    return Promise.reject(res);
                });
        },
        demoAccess({ commit, dispatch }, values) {
            return demoAccess(values)
                .then((res) => {
                    commit('demoAccessed');

                    return res;
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });

                    return Promise.reject(res);
                });
        },
        sendSmsCode({ commit, dispatch }, { form, phone }) {
            dispatch('startSmsTimer', {
                form,
                seconds: process.env.NODE_ENV === 'development' ? 5 : 60,
            });

            return sendSmsCode(phone);
        },
        confirmSmsCode({ commit }, values) {
            return confirmSmsCode(values);
        },
        startSmsTimer({ commit, dispatch, state }, timer) {
            const { form } = timer;
            let seconds = timer.seconds || state[form].seconds;

            if (!seconds) {
                return;
            }

            commit('updateTimer', {
                form,
                seconds,
            });

            const inst = setInterval(() => {
                --seconds;

                commit('updateTimer', {
                    form,
                    seconds,
                });

                if (seconds === 0) {
                    clearInterval(inst);
                }
            }, 1000);
        },
    },

    getters: {
        registeredEmail({ registeredEmail }) {
            return registeredEmail;
        },
        demoAccessed({ demoAccessed }) {
            return demoAccessed;
        }
    }
};


// WEBPACK FOOTER //
// ./src/modules/sign/store.js